<template lang="pug">
v-select(
  v-model="inputValue"
  v-bind="attrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
export default {
  name: 'AppSelect',
  components: {},
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: () => null,
    },
  },
  data() {
    return {};
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    attrs() {
      return {
        'background-color': 'redesignControlsBackground',
        'hide-details': 'auto',
        outlined: true,
        dense: true,
        ...this.$attrs,
      };
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
::v-deep.v-input {
  &.theme--light {
    color: unset;
  }

  &--is-focused.v-text-field--outlined {
    & .v-input__control {
      & fieldset {
        border-color: currentColor !important;
      }
    }
  }
}
</style>
